import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { SettingsBreadCrumbService } from '../settings-breadcrumb.service';
import { BreadCrumb } from '../../breadcrumb/breadcrumb.component';
import { IdsForSettingsService } from '../ids-for-settings.service';

@Component({
  selector: 'app-settings-subheader',
  templateUrl: './settings-subheader.component.html'
})
export class SettingsSubheaderComponent implements OnInit, OnDestroy {

  settingBreadCrumbs: BreadCrumb[] = [];
  breadCrumbSubscription: Subscription;

  selectedOrganisationName: string = "";
  organisationNameSubscription: Subscription;
  selectedUserName: string = "";
  userNameSubscription: Subscription;


  splitCurrentUrl!: string[];
  urlSplit = new URL(window.location.href).pathname.split("/");
  userFullName: string = '';
  organisationName: string = '';
  paramsSubscription!: Subscription;
  item: string | null = this.route.snapshot.params['item'];
  subitem: string | null = this.route.snapshot.params['subitem'];

  constructor(
    private route: ActivatedRoute,
    private idsForSettingsService: IdsForSettingsService,
    private settingsBreadCrumbService: SettingsBreadCrumbService) {

    this.splitCurrentUrl = new URL(window.location.href).pathname.split("/");

    this.organisationNameSubscription = this.idsForSettingsService.selectedOrganisationName$.subscribe(organisationName => {
      this.selectedOrganisationName = organisationName;
    });
    this.breadCrumbSubscription = this.settingsBreadCrumbService.settingBreadCrumbs$.subscribe(breadCrumbs => {
      this.settingBreadCrumbs = breadCrumbs;
    });
    this.userNameSubscription = this.idsForSettingsService.selectedUserName$.subscribe(userName => {
      this.selectedUserName = userName;
    });

  }

  ngOnInit() {
    this.paramsSubscription = this.route.paramMap.subscribe({
      next: (params: any) => {
        this.item = params.get('item');
        this.subitem = params.get('subitem');
      }
    });


  }

  ngOnDestroy() {
    this.breadCrumbSubscription.unsubscribe();
    this.paramsSubscription.unsubscribe();
    this.organisationNameSubscription.unsubscribe();
    this.userNameSubscription.unsubscribe();
  }


  urlCaseWord(url: string) {
    if (!url) return url;
    return url[0].toUpperCase() + url.substr(1).toLowerCase();
  }

}
